/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Status_VerifiedInputs */

const en_directory_agent_readiness_status_verified = /** @type {(inputs: Directory_Agent_Readiness_Status_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified`)
};

const zh_directory_agent_readiness_status_verified = /** @type {(inputs: Directory_Agent_Readiness_Status_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已核验`)
};

/**
* | output |
* | --- |
* | "Verified" |
*
* @param {Directory_Agent_Readiness_Status_VerifiedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_status_verified = /** @type {((inputs?: Directory_Agent_Readiness_Status_VerifiedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Status_VerifiedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_status_verified(inputs)
	return zh_directory_agent_readiness_status_verified(inputs)
});
export { directory_agent_readiness_status_verified as "directory.agent_readiness.status.verified" }